import { Card, CardContent, Typography } from '@material-ui/core'
import React from 'react'

const DataCard = ({
  name,
  value
}) => {

  return (
    <Card style={{ padding:'30px', float:'left' }}>
      <CardContent>
        <Typography variant="h5" style={{ color:'black' }}>{name}</Typography>
        <div style={{ borderTop: '1px solid black' }}>
          <Typography variant="h6" style={{ color:'black' }}>{value}</Typography>
        </div>
      </CardContent>
    </Card>
  )
}

export default DataCard